
    module.exports = function(item,array){
        var index = array.indexOf(item);
        if(index > -1){
            return array.splice(index,1);
        }
        return undefined;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/internals/removeItemFrom.js
// module id = 4491
// module chunks = 13